/**
 * External dependencies
 */
// import { ObserverResponse } from '@woocommerce/base-context';
import { ObserverResponse } from '../../base/context/event-emit';
// import { isObject, objectHasProp } from '@woocommerce/types';
import { isObject, objectHasProp } from '../index'

/**
 * Whether the passed object is an ObserverResponse.
 */
export const isObserverResponse = (
	response: unknown
): response is ObserverResponse => {
	return isObject( response ) && objectHasProp( response, 'type' );
};
